import React from "react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    img: "img/testimonials/01.jpg",
    text: "Professional delivery, clear communication, and excellent code quality throughout the project.",
    name: "Verified Client",
    role: "Web Application",
  },
  {
    img: "img/testimonials/02.jpg",
    text: "They handled both development and deployment smoothly — reliable, responsive and on time.",
    name: "Verified Client",
    role: "Mobile + Backend",
  },
  {
    img: "img/testimonials/03.jpg",
    text: "Great support even after delivery. The team understood our needs and delivered exactly that. Highly recommended.",
    name: "Verified Client",
    role: "Product Launch",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonials" className="relative bg-[#070b18] py-24 overflow-hidden">
      <div className="absolute top-0 right-1/4 w-[440px] h-[440px] rounded-full bg-violet-700/10 blur-[130px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="eyebrow reveal">Testimonials</span>
          <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
            What clients <span className="text-gradient">say</span>
          </h2>
          <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg">
            Trusted by startups and businesses for dependable, quality-focused delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className={`reveal d${(i % 3) + 1} glow-card group relative rounded-3xl p-8 glass hover:-translate-y-1.5 transition-all duration-300`}
            >
              <Quote className="h-9 w-9 text-blue-500/30 mb-4" fill="currentColor" />

              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="h-4 w-4 text-amber-400" fill="currentColor" />
                ))}
              </div>

              <blockquote className="text-slate-300 leading-relaxed">
                "{t.text}"
              </blockquote>

              <figcaption className="mt-6 flex items-center gap-3">
                <img
                  src={t.img}
                  alt={t.name}
                  loading="lazy"
                  className="h-12 w-12 rounded-full object-cover border-2 border-white/15"
                />
                <div>
                  <div className="text-white font-extrabold text-sm">{t.name}</div>
                  <div className="text-slate-500 text-xs font-semibold">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
